import ModifyAdminPasswordModal from "../../../components/modals/ModifyAdminPasswordModal";
import PromptModal from "../../../components/modals/PromptModal";
import QrCodeModal from "../../../components/modals/QrCodeModal";
import { OpeningHoursModal } from "../OpeningHours";
import MenuModal from "./MenuModal";
import MoreActionsModal from "./MoreActionsModal";
import type { ActiveModal } from "../../../helpers/types";

interface Props {
  place: Place;
  active: ActiveModal;
  setActive: (modal: ActiveModal) => void;
  isAdmin: boolean;
  onDelete: () => void;
}

export default function PlaceRowModals({
  place,
  active,
  setActive,
  isAdmin,
  onDelete,
}: Props) {
  const close = () => setActive(null);

  return (
    <>
      <MoreActionsModal
        place={place}
        visible={active === "more"}
        isAdmin={isAdmin}
        onClose={close}
        onQr={() => setActive("qr")}
        onResetPassword={() => setActive("password")}
      />
      <MenuModal
        visible={active === "menu"}
        onClose={close}
        placeId={place?.id}
      />
      <PromptModal
        open={active === "delete"}
        onAccept={onDelete}
        onClose={close}
      />
      {/* Mounted only when open: avoids one opening-hours form per row */}
      {active === "hours" && (
        <OpeningHoursModal visible onClose={close} placeId={place?.id} />
      )}
      <QrCodeModal
        visible={active === "qr"}
        onClose={close}
        slug={place?.slug}
        name={place?.name}
        category={place?.category?.slug}
      />
      <ModifyAdminPasswordModal
        visible={active === "password"}
        onClose={close}
        place={place}
      />
    </>
  );
}